/* Decorative 4.5-second passes, separated by stillness. Never mutate the signup form. */
(() => {
 if(customElements.get('ggx-newsletter-griffin-video'))return;
 customElements.define('ggx-newsletter-griffin-video',class extends HTMLElement{
  connectedCallback(){
   if(this.abort||!window.IntersectionObserver)return;
   this.video=this.querySelector('video');this.still=this.querySelector('img');this.poster=this.querySelector('.ggx-newsletter-griffin-resting');
   this.band=this.closest('.ggx-newsletter-band');this.input=this.band?.querySelector('input[type="email"]');
   if(!this.video||!this.still||!this.input||!this.video.dataset.src||this.video.dataset.src.includes('__GRIFFIN'))return;
   this.abort=new AbortController();const options={signal:this.abort.signal};this.epoch=(this.epoch||0)+1;
   this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.hoverMedia=matchMedia('(hover: hover) and (pointer: fine)');
   this.sitePaused=false;this.visible=false;this.running=false;this.hovered=false;this.hoverReady=true;this.nextAllowed=this.nextAllowed||0;
   try{this.sitePaused=['true','1'].includes(sessionStorage.getItem('ggx-living-motion-paused'));}catch{}
   this.video.muted=true;this.video.loop=false;
   this.stop=()=>{
    const wasRunning=this.running;this.epoch++;clearTimeout(this.limit);this.limit=null;this.deadline=null;this.video.pause();this.running=false;this.video.hidden=true;
    if(wasRunning){this.nextAllowed=performance.now()+5000;this.hoverReady=!this.hovered;}
    const usePoster=this.hasPlayed&&!this.failed&&!this.motion.matches&&this.poster;
    this.still.hidden=Boolean(usePoster);if(this.poster)this.poster.hidden=!usePoster;
   };
   this.addEventListener('pointerenter',e=>{
    if(!this.hoverMedia.matches||e.pointerType==='touch')return;
    this.hovered=true;const ready=this.hoverReady;this.hoverReady=false;
    if(ready&&!this.running&&this.dataset.revealed==='true'&&performance.now()>=this.nextAllowed)this.play();
   },options);
   this.addEventListener('pointerleave',e=>{
    if(e.pointerType==='touch')return;this.hovered=false;if(!this.running)this.hoverReady=true;
   },options);
   this.video.addEventListener('playing',()=>{
    if(!this.running||!this.allowed()){this.stop();return;}
    this.hasPlayed=true;this.video.hidden=false;this.still.hidden=true;if(this.poster)this.poster.hidden=true;
    // Repeated playing/buffering events must never extend the same pass.
    if(this.deadline==null){this.deadline=performance.now()+4500;this.limit=setTimeout(this.stop,4500);}
   },options);
   this.video.addEventListener('ended',this.stop,options);this.video.addEventListener('error',()=>{this.failed=true;this.stop();},options);
   this.video.addEventListener('timeupdate',()=>{if(this.video.currentTime>=4.5||(this.deadline!=null&&performance.now()>=this.deadline))this.stop();},options);
   for(const type of ['focus','input','change','animationstart'])this.input.addEventListener(type,this.stop,options);
   document.addEventListener('visibilitychange',()=>{if(document.hidden)this.stop();},options);
   window.addEventListener('pagehide',this.stop,options);
   this.motion.addEventListener('change',()=>{if(this.motion.matches)this.stop();},options);
   const preference=e=>{if(typeof e.detail?.paused!=='boolean')return;this.sitePaused=e.detail.paused;if(this.sitePaused)this.stop();};
   window.addEventListener('ggx:motion-preference',preference,options);document.addEventListener('ggx:motion-preference',preference,options);
   this.observer=new IntersectionObserver(entries=>{
    this.visible=entries.some(e=>e.isIntersecting&&e.intersectionRatio>=.5);
    if(!this.visible){this.stop();return;}
    if(this.dataset.revealed==='true'||!this.allowed())return;
    this.dataset.revealed='true';
    if(this.input.value||this.autofilled())return;
    this.play();
   },{threshold:[0,.5]});this.observer.observe(this);
  }
  allowed(){return this.isConnected&&this.visible&&!this.motion.matches&&!this.sitePaused&&!document.hidden&&this.input!==document.activeElement;}
  autofilled(){try{return this.input.matches(':autofill, :-webkit-autofill');}catch{return false;}}
  async play(){
   if(!this.allowed()||this.running||performance.now()<this.nextAllowed)return;
   this.dataset.revealed='true';this.running=true;this.deadline=null;const epoch=++this.epoch;
   if(!this.video.getAttribute('src')){this.video.src=this.video.dataset.src;this.video.load();}
   try{this.video.currentTime=0;}catch{}
   try{await this.video.play();if(epoch!==this.epoch||!this.isConnected){if(!this.running||!this.isConnected)this.video.pause();return;}if(!this.allowed())this.stop();}catch{if(epoch===this.epoch)this.stop();}
  }
  disconnectedCallback(){this.stop?.();this.observer?.disconnect();this.abort?.abort();this.abort=null;if(this.video){this.video.removeAttribute('src');this.video.load();}}
 });
})();
